import {
  LOCAL_ADD_WORK_INSTRUCTION_PACKAGE,
  LOCAL_ADD_WORK_INSTRUCTION,
  LOCAL_UPDATE_WORK_INSTRUCTION,
  LOCAL_DELETE_WORK_INSTRUCTION,
  LOCAL_ADD_WORK_INSTRUCTION_STEP,
  LOCAL_UPDATE_WORK_INSTRUCTION_STEP,
  LOCAL_DELETE_WORK_INSTRUCTION_STEP,
  LOCAL_SET_WORK_INSTRUCTION_PACKAGES,
  LOCAL_SET_WORK_INSTRUCTIONS_FOR_PACKAGE,
  LOCAL_SET_FILES_LINKED_TO_WORK_INSTRUCTION_STEP,
  LOCAL_SET_TASKS_TO_WORK_INSTRUCTION_STEP,
} from '../mutations/mutationTypes';

import client from '../../../config/api';

export default {
  ADD_WORK_INSTRUCTION_PACKAGE({ commit }, payload) {
    client.post('/work-instructions-package', payload);
    commit(LOCAL_ADD_WORK_INSTRUCTION_PACKAGE, payload);
  },

  FETCH_WORK_INSTRUCTION_PACKAGES: async ({ commit }, jobId) => {
    const response = await client.get(
      `/work-instructions-package/job/${jobId}`
    );
    const packages = response.data;

    commit(LOCAL_SET_WORK_INSTRUCTION_PACKAGES, packages);
  },

  ADD_WORK_INSTRUCTION({ commit }, payload) {
    client.post(`/work-instructions/package/${payload.packageId}`, payload);
    commit(LOCAL_ADD_WORK_INSTRUCTION, payload);
  },

  UPDATE_WORK_INSTRUCTION({ commit }, payload) {
    client.put(`/work-instructions/${payload._id}`, payload);
    commit(LOCAL_UPDATE_WORK_INSTRUCTION, payload);
  },

  DELETE_WORK_INSTRUCTION({ commit }, { instructionId }) {
    client.delete(`/work-instructions/${instructionId}`);
    commit(LOCAL_DELETE_WORK_INSTRUCTION, { instructionId });
  },

  ADD_WORK_INSTRUCTION_STEP({ commit }, payload) {
    client.post(
      `/work-instructions/step/${payload.instructionId}`,
      payload.step
    );
    commit(LOCAL_ADD_WORK_INSTRUCTION_STEP, {
      instructionId: payload.instructionId,
      step: payload.step,
    });
  },

  UPDATE_WORK_INSTRUCTION_STEP({ commit }, payload) {
    client.put(
      `/work-instructions/step/${payload.instructionId}/${payload.step._id}`,
      payload.step
    );
    commit(LOCAL_UPDATE_WORK_INSTRUCTION_STEP, {
      instructionId: payload.instructionId,
      step: payload.step,
    });
  },

  DELETE_WORK_INSTRUCTION_STEP({ commit }, { instructionId, stepId }) {
    client.delete(`/work-instructions/step/${instructionId}/${stepId}`);
    commit(LOCAL_DELETE_WORK_INSTRUCTION_STEP, {
      instructionId,
      stepId,
    });
  },

  FETCH_WORK_INSTRUCTIONS_FOR_PACKAGE: async ({ commit }, packageId) => {
    const response = await client.get(
      `/work-instructions/package/${packageId}`
    );
    const workInstructions = response.data;
    commit(LOCAL_SET_WORK_INSTRUCTIONS_FOR_PACKAGE, workInstructions);
  },

  LINK_FILES_TO_WORK_INSTRUCTION_STEP(
    { commit },
    { instructionId, files, stepId }
  ) {
    const fileIds = files.map((entry) => entry._id);
    client.post(`/work-instructions/link-files/${instructionId}`, {
      fileIds,
      stepId,
    });
    commit(LOCAL_SET_FILES_LINKED_TO_WORK_INSTRUCTION_STEP, {
      instructionId,
      files,
      stepId,
    });
  },

  LINK_TASKS_TO_WORK_INSTRUCTION_STEP(
    { commit },
    { instructionId, tasks, stepId }
  ) {
    const taskIds = tasks.map((entry) => entry._id);
    client.post(`/work-instructions/link-tasks/${instructionId}`, {
      taskIds,
      stepId,
    });

    commit(LOCAL_SET_TASKS_TO_WORK_INSTRUCTION_STEP, {
      instructionId,
      tasks,
      stepId,
    });
  },
};
